(function () {
  "use strict";

  document.addEventListener("DOMContentLoaded", function () {
    if (new URLSearchParams(window.location.search).get("mode") !== "view") return;
    var root = document.querySelector("[data-cp-viewer]");
    if (!root) return;

    var CP = window.CustomPoster;
    CP.loadGoogleFonts();

    var state = CP.decodeState(window.location.search);
    var canvas = root.querySelector("[data-cp-canvas]");
    var ctx = canvas.getContext("2d");
    var dimensions = CP.canvasDimensionsForSize(state.size);
    canvas.width = dimensions.width;
    canvas.height = dimensions.height;
    canvas.style.aspectRatio = dimensions.width + " / " + dimensions.height;

    var infoEl = root.querySelector("[data-cp-info]");
    var downloadBtn = root.querySelector("[data-cp-download]");

    // GUVENLIK: Bu sayfadaki TUM degerler URL sorgusundan gelir (musterinin yazdigi metin,
    // sekil etiketi, renk kodlari...). Daha once bunlar innerHTML ile birlestiriliyordu;
    // kotu niyetli bir musteri tasarim metnine HTML/script koyup, magaza sahibi siparisteki
    // "Tasarim Linki"ni actiginda storefront origin'inde kod calistirabilirdi.
    // Artik her deger textContent ile yaziliyor, yani HTML olarak DEGIL duz metin olarak
    // islenir. Yalnizca bizim urettigimiz sabit yapi (div/strong/br/hr) DOM ile kuruluyor.
    if (infoEl) {
      var NBSP2 = "  ";

      function labeledLine(labelText, valueText) {
        var frag = document.createDocumentFragment();
        var b = document.createElement("strong");
        b.textContent = labelText;
        frag.appendChild(b);
        frag.appendChild(document.createTextNode(" " + valueText));
        return frag;
      }

      function infoRow(labelText, valueText) {
        var div = document.createElement("div");
        div.appendChild(labeledLine(labelText, valueText));
        return div;
      }

      infoEl.textContent = "";

      var bgColorsText = (state.bgParts || [])
        .map(function (p) { return CP.bgRoleLabel(p) + ": " + ((state.bgColors || {})[p] || ""); })
        .join(NBSP2);
      infoEl.appendChild(
        infoRow("Arka plan:", (state.bgLabel || "-") + (bgColorsText ? " (" + bgColorsText + ")" : ""))
      );
      infoEl.appendChild(infoRow("Beyaz kenar boşluğu:", state.paspartu ? "Evet" : "Hayır"));
      infoEl.appendChild(infoRow("Boyut:", state.size || "-"));

      var hr = document.createElement("hr");
      hr.style.border = "none";
      hr.style.borderTop = "1px solid #ddd";
      hr.style.margin = "12px 0";
      infoEl.appendChild(hr);

      state.layers.forEach(function (l, idx) {
        var wrap = document.createElement("div");
        wrap.style.marginBottom = "8px";
        wrap.style.paddingBottom = "8px";
        if (idx < state.layers.length - 1) wrap.style.borderBottom = "1px solid #e0e0e0";

        if (l.type === "shape") {
          var rolesText = (l.parts || [])
            .map(function (p) { return (CP.SHAPE_ROLE_LABELS[p] || p) + ": " + (l.colors[p] || ""); })
            .join(NBSP2);
          wrap.appendChild(labeledLine("Şekil " + (idx + 1) + ":", l.shapeLabel || "-"));
          wrap.appendChild(document.createElement("br"));
          wrap.appendChild(document.createTextNode(rolesText));
        } else {
          var fontLabel = (CP.FONTS.filter(function (f) { return f.id === l.font; })[0] || {}).label || l.font;
          var weightLabel = (CP.WEIGHTS.filter(function (w) { return w.id === l.weight; })[0] || {}).label || l.weight;
          wrap.appendChild(labeledLine("Metin " + (idx + 1) + ":", l.text));
          wrap.appendChild(document.createElement("br"));
          wrap.appendChild(
            labeledLine("Font:", fontLabel + " (" + weightLabel + (l.italic ? ", İtalik" : "") + ")" + NBSP2)
          );
          wrap.appendChild(labeledLine("Renk:", l.color));
        }

        infoEl.appendChild(wrap);
      });
    }

    var shapeImages = {};

    function render(bgImg) {
      CP.drawComposition(ctx, canvas.width, canvas.height, state, bgImg, shapeImages, { showPlaceholders: false });
    }

    var shapeLayers = state.layers.filter(function (l) { return l.type === "shape" && l.shapeUrl; });

    var bgImgResult = null;
    Promise.all(
      shapeLayers.map(function (l) {
        return CP.loadTintedShapeImage(l).then(function (img) {
          shapeImages[CP.shapeImageKey(l)] = img;
        }).catch(function () {});
      })
    ).then(function () {
      render(bgImgResult);
    });

    render(null);
    var bgLoader = state.bgParts && state.bgParts.length
      ? CP.loadTintedBackgroundImage({ url: state.bg, parts: state.bgParts }, state.bgColors)
      : CP.loadImage(state.bg);
    bgLoader
      .then(function (img) {
        bgImgResult = img;
        render(img);
      })
      .catch(function () {
        /* arka plan yuklenemezse bile diger katmanlari gostermeye devam et */
      });

    if (downloadBtn) {
      downloadBtn.addEventListener("click", function () {
        canvas.toBlob(function (blob) {
          var url = URL.createObjectURL(blob);
          var a = document.createElement("a");
          a.href = url;
          a.download = "tasarim-" + Date.now() + ".png";
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          setTimeout(function () { URL.revokeObjectURL(url); }, 5000);
        }, "image/png");
      });
    }
  });
})();
